import { spAnnouncementsListLocs } from './list/announcements-list.locs';
import { spAnnouncementsDetailsLocs } from './outlet/details/details.locs';

export const spToolsAnnouncementsModuleLocs = {
	...spAnnouncementsListLocs,
	...spAnnouncementsDetailsLocs,
};
